import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store/store';
import {MsalProvider} from '@azure/msal-react'
import { initializeMsal, msalInstance } from './auth/msalConfig';


const Root =()=>{
  const [isMsalInitialized,setIsMsalInitialized]= useState(false);

  useEffect(()=>{
    const init= async ()=>{
      await initializeMsal();
      setIsMsalInitialized(true);
    }
    init();
  },[])

  if(!isMsalInitialized) return <div>Loading..</div>

  return(
    <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <App />
      </Provider>
    </MsalProvider>
  </React.StrictMode>
  )
}
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Root/>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
